<div class="journal-details-container">
  <!-- KPI Tiles Section -->
  <div class="kpi-tiles-row">
    <!-- Total KPI Tile -->
    <div
      class="kpi-tile"
      [class.active]="activeFilter === null"
      [ngClass]="'kpi-tile-' + totalKpiTile.status"
      (click)="onTotalTileClick()"
      (keydown.enter)="onTotalTileClick()"
      tabindex="0"
      role="button"
      >
      <div class="kpi-tile-icon">
        <i class="fa-solid" [ngClass]="totalKpiTile.icon"></i>
      </div>
      <div class="kpi-tile-content">
        <div class="kpi-tile-count">
          @if (!totalKpiTile.loading) {
            <span>{{ totalKpiTile.count }}</span>
          }
          @if (totalKpiTile.loading) {
            <i
              class="fa-solid fa-spinner fa-spin"
            ></i>
          }
        </div>
        <div class="kpi-tile-title">{{ totalKpiTile.title }}</div>
      </div>
    </div>

    <!-- Status KPI Tiles -->
    @for (tile of kpiTiles; track tile) {
      @if (
        (tile.filterValue !== 'Waiting Count' ||
        journalStatus === 'Ready' ||
        journalStatus === 'InProgress') &&
        (tile.filterValue !== 'Not Found' ||
        (journalStatus !== 'Ready' && journalStatus !== 'InProgress')) &&
        (tile.filterValue !== 'Missing' ||
        (journalStatus !== 'Ready' && journalStatus !== 'InProgress'))
        ) {
        <div
          class="kpi-tile"
          [class.active]="activeFilter === tile.filterValue"
          [ngClass]="'kpi-tile-' + tile.status"
          (click)="onTileClick(tile)"
          (keydown.enter)="onTileClick(tile)"
          tabindex="0"
          role="button"
          >
          <div class="kpi-tile-icon">
            <i class="fa-solid" [ngClass]="tile.icon"></i>
          </div>
          <div class="kpi-tile-content">
            <div class="kpi-tile-count">
              @if (!tile.loading) {
                <span>{{ tile.count }}</span>
              }
              @if (tile.loading) {
                <i class="fa-solid fa-spinner fa-spin"></i>
              }
            </div>
            <div class="kpi-tile-title">{{ tile.title }}</div>
          </div>
        </div>
      }
    }
  </div>

  <!-- Action Buttons Section -->
  <div class="action-buttons-row d-flex">
    <!-- Found Equipment - shows for InProgress and Recount -->
    @if (
      journalStatus === 'InProgress' ||
      journalStatus === 'Recount' ||
      journalStatus === 'Ready'
      ) {
      <grid-menu-button
        [button]="buttons[5]"
        [disabled]="isAddingEquipment || isAddingWriteIn"
        [nbContextMenu]="addEquipmentMenuItems"
        nbContextMenuTag="addEquipmentMenu"
        nbContextMenuPlacement="bottom"
      ></grid-menu-button>
    }
    <!-- Refresh - always visible -->
    <grid-menu-button
      [button]="buttons[1]"
      (click)="handleRefreshClick()"
      (keydown.enter)="handleRefreshClick()"
    ></grid-menu-button>
    <!-- Delete Line - shows for InProgress and Recount, only enabled when a line with status 'Added' is selected -->
    @if (
      journalStatus === 'InProgress' ||
      journalStatus === 'Recount' ||
      journalStatus === 'Ready'
      ) {
      <grid-menu-button
        [button]="buttons[6]"
        [disabled]="!canDeleteSelectedLine()"
        (click)="deleteLineConfirm(deleteLineDialog)"
        (keydown.enter)="deleteLineConfirm(deleteLineDialog)"
      ></grid-menu-button>
    }
    <!-- Share - always visible -->
    <grid-menu-button
      [button]="buttons[7]"
      (click)="shareJournal(shareDialog)"
      (keydown.enter)="shareJournal(shareDialog)"
    ></grid-menu-button>
  </div>

  <!-- Journal Lines List -->
  <div class="journal-lines-section">
    <next-object-list
      #journalLinesList
      object="EquipmentCountingJournalLine"
      [height]="500"
      [pagination_count]="100"
      [hideToolBar]="true"
      [hideQueues]="false"
      [hideControlBar]="false"
      [filters]="filters"
      (onDoubleClick)="onLineDoubleClick($event)"
      (onSelect)="onLineSelect($event)"
    ></next-object-list>
  </div>
</div>

<!-- Share Journal Link Dialog -->
<ng-template #shareDialog let-data let-ref="dialogRef">
  <nb-card style="width: 420px; max-width: 90vw">
    <nb-card-header
      class="dialog-header"
      style="display: flex; justify-content: center"
      >Share Journal
    </nb-card-header>
    <nb-card-body>
      <p style="margin-bottom: 8px">
        Anyone with this link can view this journal for 14 days.
      </p>
      @if (isLoadingShareLink) {
        <div style="display: flex; justify-content: center; padding: 8px">
          <i class="fa-solid fa-spinner fa-spin"></i>
        </div>
      }
      @if (!isLoadingShareLink && shareLinkURL) {
        <nb-form-field>
          <input
            id="ecj-share-link-input"
            aria-label="Share link URL"
            nbInput
            fullWidth
            readonly
            [value]="shareLinkURL"
            />
          <button
            nbSuffix
            nbButton
            ghost
            type="button"
            (click)="copyShareLink()"
            >
            <nb-icon
              [icon]="shareLinkCopied ? 'checkmark-outline' : 'copy-outline'"
              pack="eva"
            ></nb-icon>
          </button>
        </nb-form-field>
      }
      @if (!isLoadingShareLink && batchShareLinkURL) {
        <p style="margin: 16px 0 8px">
          This journal was created in a batch. The batch link combines
          all journals from the batch into one searchable page.
        </p>
        <nb-form-field>
          <input
            id="ecj-batch-share-link-input"
            aria-label="Batch share link URL"
            nbInput
            fullWidth
            readonly
            [value]="batchShareLinkURL"
            />
          <button
            nbSuffix
            nbButton
            ghost
            type="button"
            (click)="copyBatchShareLink()"
            >
            <nb-icon
              [icon]="batchShareLinkCopied ? 'checkmark-outline' : 'copy-outline'"
              pack="eva"
            ></nb-icon>
          </button>
        </nb-form-field>
      }
      @if (!isLoadingShareLink && !shareLinkURL) {
        <p style="color: #ff3d71">
          Unable to generate a share link. Please try again.
        </p>
      }
    </nb-card-body>
    <nb-card-footer
      class="codes-dialog"
      style="display: flex; justify-content: flex-end"
      >
      <button nbButton (click)="ref.close()">Close</button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<!-- Run Variance Confirmation Dialog -->
<ng-template #varianceDialog let-data let-ref="dialogRef">
  <nb-card accent="warning">
    <nb-card-header
      class="dialog-header"
      style="display: flex; justify-content: center"
      >Run Variance?
    </nb-card-header>
    <nb-card-body>
      <div style="display: flex; justify-content: center">
        <nb-icon
          style="font-size: 4rem; color: #ffaa00"
          icon="alert-circle-outline"
        ></nb-icon>
      </div>
      <p>
        This will mark all <b>Waiting</b> items as <b>Not Found</b> and update
        the journal status.
      </p>
      @if (getWaitingCount() > 0) {
        <p>
          <b>{{ getWaitingCount() }}</b> item(s) will be marked as Not Counted.
        </p>
      }
      @if (getWaitingCount() === 0) {
        <p>
          No items are waiting to be counted. The journal will be marked as
          <b>Completed</b>.
        </p>
      }
    </nb-card-body>
    <nb-card-footer
      class="codes-dialog"
      style="display: flex; justify-content: space-between; gap: 8px"
      >
      <button nbButton (click)="ref.close()" [disabled]="isConfirmingVariance">
        Cancel
      </button>
      <button
        nbButton
        status="warning"
        (click)="runVariance(ref)"
        [disabled]="isConfirmingVariance"
        >
        @if (!isConfirmingVariance) {
          <span>Run Variance</span>
        }
        @if (isConfirmingVariance) {
          <i class="fa-solid fa-spinner fa-spin"></i>
        }
        @if (isConfirmingVariance) {
          <span> Processing...</span>
        }
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<!-- Complete Count Confirmation Dialog -->
<ng-template #completeCountDialog let-data let-ref="dialogRef">
  <nb-card accent="success">
    <nb-card-header
      class="dialog-header"
      style="display: flex; justify-content: center"
      >Complete Count?
    </nb-card-header>
    <nb-card-body>
      <div style="display: flex; justify-content: center">
        <nb-icon
          style="font-size: 4rem; color: #00d68f"
          icon="checkmark-circle-2-outline"
        ></nb-icon>
      </div>
      <p>This will mark the journal as <b>Completed</b>.</p>
      <p>All counting activities for this journal will be finalized.</p>
    </nb-card-body>
    <nb-card-footer
      class="codes-dialog"
      style="display: flex; justify-content: space-between; gap: 8px"
      >
      <button nbButton (click)="ref.close()" [disabled]="isCompletingCount">
        Cancel
      </button>
      <button
        nbButton
        status="success"
        (click)="completeCount(ref)"
        [disabled]="isCompletingCount"
        >
        @if (!isCompletingCount) {
          <span>Complete Count</span>
        }
        @if (isCompletingCount) {
          <i class="fa-solid fa-spinner fa-spin"></i>
        }
        @if (isCompletingCount) {
          <span> Processing...</span>
        }
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<!-- Cancel Journal Confirmation Dialog -->
<ng-template #cancelDialog let-data let-ref="dialogRef">
  <nb-card accent="danger">
    <nb-card-header
      class="dialog-header"
      style="display: flex; justify-content: center"
      >Cancel Journal?
    </nb-card-header>
    <nb-card-body>
      <div style="display: flex; justify-content: center">
        <nb-icon
          style="font-size: 4rem; color: #ff3d71"
          icon="close-circle-outline"
        ></nb-icon>
      </div>
      <p>This will mark the journal as <b>Cancelled</b>.</p>
      <p>All counting activities for this journal will be stopped.</p>
    </nb-card-body>
    <nb-card-footer
      class="codes-dialog"
      style="display: flex; justify-content: space-between; gap: 8px"
      >
      <button nbButton (click)="ref.close()" [disabled]="isCancellingJournal">
        Cancel
      </button>
      <button
        nbButton
        status="danger"
        (click)="cancelJournal(ref)"
        [disabled]="isCancellingJournal"
        >
        @if (!isCancellingJournal) {
          <span>Cancel Journal</span>
        }
        @if (isCancellingJournal) {
          <i class="fa-solid fa-spinner fa-spin"></i>
        }
        @if (isCancellingJournal) {
          <span> Processing...</span>
        }
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<!-- Delete Journal Confirmation Dialog -->
<ng-template #deleteDialog let-data let-ref="dialogRef">
  <nb-card accent="danger">
    <nb-card-header
      class="dialog-header"
      style="display: flex; justify-content: center"
      >Delete Journal?
    </nb-card-header>
    <nb-card-body>
      <div style="display: flex; justify-content: center">
        <nb-icon
          style="font-size: 4rem; color: #ff3d71"
          icon="trash-2-outline"
        ></nb-icon>
      </div>
      <p>This will permanently <b>delete</b> the journal.</p>
      <p>This action cannot be undone.</p>
    </nb-card-body>
    <nb-card-footer
      class="codes-dialog"
      style="display: flex; justify-content: space-between; gap: 8px"
      >
      <button nbButton (click)="ref.close()" [disabled]="isDeletingJournal">
        Cancel
      </button>
      <button
        nbButton
        status="danger"
        (click)="deleteJournal(ref)"
        [disabled]="isDeletingJournal"
        >
        @if (!isDeletingJournal) {
          <span>Delete Journal</span>
        }
        @if (isDeletingJournal) {
          <i class="fa-solid fa-spinner fa-spin"></i>
        }
        @if (isDeletingJournal) {
          <span> Processing...</span>
        }
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<!-- Equipment Selection Dialog -->
<ng-template #equipmentListDialog let-ref="dialogRef">
  <nb-card class="margin-bottom-0" style="width: 700px">
    <nb-card-header
      style="display: flex; justify-content: space-between; align-items: center"
      >
      <b>Add Found Equipment to Journal</b>
      <button nbButton ghost size="small" (click)="closeEquipmentPopover()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </nb-card-header>
    <nb-card-body class="p-0">
      <next-object-list
        object="Equipment"
        [showQuickSearch]="true"
        [searchPlaceholder]="'Search by Fleet Code, Serial, or Equipment #'"
        [quickSearchColumns]="['fleetCode', 'serial', 'equipmentNum']"
        [height]="400"
        [hideToolBar]="true"
        [hideQueues]="true"
        [hideControlBar]="true"
        (onSelect)="onSelectEquipmentToAdd($event)"
      ></next-object-list>
    </nb-card-body>
    <nb-card-footer style="display: flex; justify-content: flex-end; gap: 8px">
      <button
        nbButton
        status="basic"
        size="small"
        (click)="closeEquipmentPopover()"
        >
        Cancel
      </button>
      <button
        nbButton
        [status]="'success'"
        [disabled]="!selectedEquipmentToAdd?.length || isAddingEquipment"
        size="small"
        (click)="addEquipmentToJournal()"
        >
        <nb-icon icon="plus-outline"></nb-icon>
        @if (!isAddingEquipment) {
          <span>
            {{
            selectedEquipmentToAdd?.length
            ? 'Add ' + selectedEquipmentToAdd?.length + ' Equipment'
            : 'Add'
            }}
          </span>
        }
        @if (isAddingEquipment) {
          <span>
            <i class="fa-solid fa-spinner fa-spin"></i> Adding...
          </span>
        }
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>

<!-- Write-In Equipment Dialog -->
<ng-template #writeInDialog let-ref="dialogRef">
  <nb-card class="margin-bottom-0" style="width: 400px">
    <nb-card-header
      style="display: flex; justify-content: space-between; align-items: center"
      >
      <b>Write-In Equipment</b>
      <button nbButton ghost size="small" (click)="closeWriteInPopover()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </nb-card-header>
    <nb-card-body>
      <form [formGroup]="writeInForm">
        <div class="form-group mb-3">
          <label for="write-in-serial" class="label"
            >Serial Number <span class="text-danger">*</span></label
            >
            <input
              nbInput
              fullWidth
              formControlName="equipmentSerial"
              placeholder="Enter serial number"
              id="write-in-serial"
              />
          </div>
          <div class="form-group mb-3">
            <label class="label"
              >Station <span class="text-danger">*</span></label
              >
              <stack-mono-dynamic-input
                objectType="Station"
                (objectChange)="onWriteInStationChange($event)"
                displayField="station"
                searchFields="station"
                [placeholder]="'Select Station'"
                [searchFields]="['station']"
                [selectedObject]="selectedWriteInStation"
                [fieldSize]="'small'"
                [required]="true"
              ></stack-mono-dynamic-input>
            </div>
            <div class="form-group mb-3">
              <label for="write-in-make" class="label">Make</label>
              <input
                nbInput
                fullWidth
                formControlName="equipmentMake"
                placeholder="Enter make"
                id="write-in-make"
                />
            </div>
            <div class="form-group mb-3">
              <label for="write-in-model" class="label">Model</label>
              <input
                nbInput
                fullWidth
                formControlName="equipmentModel"
                placeholder="Enter model"
                id="write-in-model"
                />
            </div>
            <div class="form-group mb-0">
              <label for="write-in-notes" class="label">Notes</label>
              <textarea
                nbInput
                fullWidth
                formControlName="notes"
                placeholder="Enter notes"
                rows="3"
                id="write-in-notes"
              ></textarea>
            </div>
          </form>
        </nb-card-body>
        <nb-card-footer style="display: flex; justify-content: flex-end; gap: 8px">
          <button
            nbButton
            status="basic"
            size="small"
            (click)="closeWriteInPopover()"
            >
            Cancel
          </button>
          <button
            nbButton
            [status]="'success'"
            [disabled]="!isWriteInFormValid() || isAddingWriteIn"
            size="small"
            (click)="addWriteInEquipment()"
            >
            <nb-icon icon="plus-outline"></nb-icon>
            @if (!isAddingWriteIn) {
              <span>Add</span>
            }
            @if (isAddingWriteIn) {
              <span>
                <i class="fa-solid fa-spinner fa-spin"></i> Adding...
              </span>
            }
          </button>
        </nb-card-footer>
      </nb-card>
    </ng-template>

    <!-- Delete Line Confirmation Dialog -->
    <ng-template #deleteLineDialog let-data let-ref="dialogRef">
      <nb-card accent="danger">
        <nb-card-header
          class="dialog-header"
          style="display: flex; justify-content: center"
          >Delete Line?
        </nb-card-header>
        <nb-card-body>
          <div style="display: flex; justify-content: center">
            <nb-icon
              style="font-size: 4rem; color: #ff3d71"
              icon="trash-2-outline"
            ></nb-icon>
          </div>
          <p>This will permanently <b>delete</b> the selected journal line.</p>
          @if (selectedLine) {
            <p>
              Equipment:
              <b>{{
                selectedLine.equipment?.equipmentNum ||
                selectedLine.equipmentSerial ||
                'Unknown'
              }}</b>
            </p>
          }
          <p>This action cannot be undone.</p>
        </nb-card-body>
        <nb-card-footer
          class="codes-dialog"
          style="display: flex; justify-content: space-between; gap: 8px"
          >
          <button nbButton (click)="ref.close()" [disabled]="isDeletingLine">
            Cancel
          </button>
          <button
            nbButton
            status="danger"
            (click)="deleteLine(ref)"
            [disabled]="isDeletingLine"
            >
            @if (!isDeletingLine) {
              <span>Delete Line</span>
            }
            @if (isDeletingLine) {
              <i class="fa-solid fa-spinner fa-spin"></i>
            }
            @if (isDeletingLine) {
              <span> Processing...</span>
            }
          </button>
        </nb-card-footer>
      </nb-card>
    </ng-template>
